/* ==========================================================
   DAILY RHYTHM TIMELINE — Scroll Animation
========================================================== */
(function() {
  'use strict';
  function initDailyRhythm() {
    var sections = document.querySelectorAll('.daily-rhythm');
    if (!sections.length) return;

    if (window.Shopify && window.Shopify.designMode) {
      document.querySelectorAll('.dr-animate').forEach(function(el) { el.classList.add('is-visible'); });
      document.querySelectorAll('.daily-rhythm__line').forEach(function(el) { el.classList.add('is-drawing'); });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.dr-animate').forEach(function(el) { el.classList.add('is-visible'); });
      document.querySelectorAll('.daily-rhythm__line').forEach(function(el) { el.classList.add('is-drawing'); });
      return;
    }

    sections.forEach(function(section) {
      var line = section.querySelector('.daily-rhythm__line');
      var points = section.querySelectorAll('.daily-rhythm__point');
      var header = section.querySelector('.daily-rhythm__header');
      var label = section.querySelector('.daily-rhythm__label');

      var headerObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            headerObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });

      if (header) headerObserver.observe(header);
      if (label) headerObserver.observe(label);

      var timelineEl = section.querySelector('.daily-rhythm__timeline');
      if (!timelineEl) return;

      var timelineFired = false;
      var timelineObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !timelineFired) {
            timelineFired = true;
            timelineObserver.unobserve(entry.target);
            if (line) line.classList.add('is-drawing');
            
            var lineDrawDuration = 2200; 
            var totalPoints = points.length;
            points.forEach(function(point, index) {
              var fraction = totalPoints > 1 ? index / (totalPoints - 1) : 0;
              var delay = 400 + (fraction * lineDrawDuration * 0.85);
              setTimeout(function() { point.classList.add('is-visible'); }, delay);
            });
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
      timelineObserver.observe(timelineEl);
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initDailyRhythm); } 
  else { initDailyRhythm(); }

  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('.daily-rhythm')) initDailyRhythm();
  });
})();